import type { ReactNode } from 'react';
import type { Status } from '../api/client';
import { STATUS_TEXT, STATUS_ZEICHEN } from '../format';

/** Ampel immer mit Text und Zeichen, nie nur Farbe. */
export function StatusPill({ status, text }: { status: Status; text?: string }) {
  return (
    <span className={`status status--${status}`}>
      <span className="status__zeichen" aria-hidden="true">
        {STATUS_ZEICHEN[status]}
      </span>
      {text ?? STATUS_TEXT[status]}
    </span>
  );
}

export function Meldung({
  art,
  children,
}: {
  art: 'fehler' | 'info' | 'erfolg';
  children: ReactNode;
}) {
  return (
    <div className={`meldung meldung--${art}`} role={art === 'fehler' ? 'alert' : 'status'}>
      {children}
    </div>
  );
}

export function Feld({
  label,
  children,
  hinweis,
}: {
  label: string;
  children: ReactNode;
  hinweis?: string;
}) {
  return (
    <label className="feld">
      <span className="feld__label">{label}</span>
      {children}
      {hinweis && <span className="feld__hinweis">{hinweis}</span>}
    </label>
  );
}

export function Karte({
  titel,
  children,
  aktion,
}: {
  titel?: string;
  children: ReactNode;
  aktion?: ReactNode;
}) {
  return (
    <section className="kasten">
      {(titel || aktion) && (
        <header className="kasten__kopf">
          {titel && <h2>{titel}</h2>}
          {aktion}
        </header>
      )}
      {children}
    </section>
  );
}

/** Kennzeichnung für Werte, die nur Annahmen aus dem Regelwerk sind. */
export function Annahme({ children }: { children?: ReactNode }) {
  return (
    <span className="annahme" title="Annahme aus dem Regelwerk – keine Norm, anpassbar">
      Annahme{children ? <>: {children}</> : null}
    </span>
  );
}

export function fehlerText(e: unknown): string {
  return e instanceof Error ? e.message : String(e);
}
